import axios from 'axios';

import { JsonResponse } from 'core/models/response';
import { PackagesResponse, PaymentStatusResponse, PaymentUrlResponse } from '../models/wallet';

export const onGetPackages = async () => {
	try {
		const response = await axios.get<JsonResponse<PackagesResponse>>('dashboard/point-plans');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetPaymentLink = async (type: 'point_package_id' | 'custom_amount', value: number) => {
	try {
		const response = await axios.post<JsonResponse<PaymentUrlResponse>>('dashboard/points/payment-url', { [type]: value });
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

export const onGetPaymentStatus = async (merchantId: string) => {
	try {
		const response = await axios.get<JsonResponse<PaymentStatusResponse>>(`dashboard/payments/${merchantId}/status`);
		return response.data.data;
	} catch (error) {
		throw error;
	}
};
